import { useMemo, type FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppParagraph, GroupTag } from "@/shared/Components";
import { CakeIcon } from "@/shared/icons";
import type { Group } from "@/shared/Components";
import type { PersonInfoCardProps } from "../types";
import { getAge } from "../helpers";
import styles from "./styles.module.scss";

export const View: FC<PersonInfoCardProps> = ({ content, layout }) => {
  const { t } = useTranslation();

  const { work, birthdaySDate, name, birthday, gender } = content;

  const ageAndGender = useMemo(() => {
    const age = getAge(birthdaySDate);

    const parsedGender = gender && gender !== "NOT_DEFINED" && t(`common.${gender.toLowerCase()}`);

    const parsedAge = !!age && `${age} ${t("common.years")}`;

    return [parsedGender, parsedAge].filter(Boolean).join(", ") || undefined;
  }, [birthdaySDate, gender]);

  return (
    <div className={styles["info-container"]}>
      <div className={classNames(styles.info, styles[`${layout}`])}>
        {content.group && <GroupTag group={content.group as Group} className={styles.tag} />}
        <AppParagraph size="xs" weight="medium" lineHeight="sm" className={styles.work}>
          {work}
        </AppParagraph>
        <AppParagraph size="lg" weight="semibold" lineHeight="xl" className={styles.name}>
          {name}
        </AppParagraph>
        {ageAndGender && (
          <AppParagraph
            size="xs"
            weight="semibold"
            lineHeight="sm"
            className={styles["age-and-gender"]}
          >
            {ageAndGender}
          </AppParagraph>
        )}
        {birthday && (
          <div className={styles["birthday-container"]}>
            <CakeIcon />
            <AppParagraph size="sm" className={styles.birthday}>
              {birthday}
            </AppParagraph>
          </div>
        )}
      </div>
    </div>
  );
};
